import classNames from "classnames";

export default function DotSpinner({
  size = 45,          
  color = "#A1F69E",
  speed = 0.9,        
  className = ""
}) {
  const dots = new Array(8).fill(0);

  return (
    <div
      className={classNames("relative flex items-center justify-start", className)}
      style={{
        width: size,
        height: size,
      }}
    >
      {dots.map((_, i) => (
        <div
          key={i}
          className="absolute top-0 left-0 w-full h-full flex items-center justify-start"
          style={{
            transform: `rotate(${i * 45}deg)`
          }}
        >
          <span
            className="rounded-full opacity-50 animate-dotPulse"
            style={{
              width: "20%",
              height: "20%",
              backgroundColor: color,
              animationDuration: `${speed * 1.111}s`,
              animationDelay: `${speed * (-0.875 + i * 0.125)}s`,
              boxShadow: "0 0 20px rgba(18,31,53,0.3)"
            }}
          />
        </div>
      ))}
    </div>
  );
}